import DashboardAlerts from "@/components/dashboard/DashboardAlerts.vue";
import CentralAlertas from "@/components/dashboard/CentralAlertas.vue";
import { isMonitoringEnabled } from "@/services/config";

const dashboardAlertsRoutes = [
  {
    path: "/dashboard-alerts",
    name: "dashboard-alerts",
    meta: {
      enabled: isMonitoringEnabled,
    },
    component: DashboardAlerts,
  },
  {
    path: "/central-alertas",
    name: "central-alertas",
    meta: {
      enabled: isMonitoringEnabled,
    },
    component: CentralAlertas,
  },
];

export default dashboardAlertsRoutes;
